import React from "react";
import axios from "axios";
import './style.css';
import { API_URL, ERROR_HANDLE } from "../../../../config/constants";

const TOTAL_USERS = "TOTAL UNIQUE USERS";
const ONE_TIME_USERS = "1-TIME USERS";
const REPEAT_USERS = "REPEAT USERS";

class Overview extends React.Component {

    state = {
        selectedBrand: 'FLEXIT ALL VPT',
        usersCount: {}
    }

    componentDidMount() {
        this.getOverview()
    }

    getOverview = () => {
        const access_token = localStorage.getItem("access_token");
        axios.get(`${API_URL}/admin/virtualTraining/overview`, {
            headers: {
                "x-access-token": access_token
            }
        }).then(res => {
            this.setState({
                usersCount: res.data[this.state.selectedBrand].usersCount
            })
        }).catch(error => {
            ERROR_HANDLE(error)
        })
    }
    
    render() {
        return(
            <div className="content">
                <div className="cell">
                    <div className="brand">
                        {this.state.selectedBrand}
                    </div>
                    <div className="card">
                        {this.renderUserCounts()}
                    </div>
                </div>
            </div>
        )
    }

    renderUserCounts = () => {
        const { usersCount } = this.state
        return (
            <div className="d-flex flex-column">
                <div className="d-flex justify-content-start">
                    <div className="brand label">{TOTAL_USERS}</div>
                    <div className="brand count">{usersCount.totalUniqueUsers != undefined ? usersCount.totalUniqueUsers : "-"}</div>
                </div>
                <div style={{display:'flex', flexDirection:'row', marginTop: 20}}>
                    <div className="d-flex flex-column justify-content-start">
                        <div className="brand label">{ONE_TIME_USERS}</div>
                        <div className="brand count">{usersCount.totalUniqueUsers != undefined ? usersCount.totalUniqueUsers : "-"}</div>
                    </div>
                    <div className="divider"/>
                    <div className="d-flex flex-column justify-content-start">
                        <div className="brand label">{REPEAT_USERS}</div>
                        <div className="brand count">{usersCount.totalUniqueUsers != undefined ? usersCount.totalUniqueUsers : "-"}</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Overview;